export default[
    {
        title: 'Webinars',
        icon: 'PlayCircleIcon',
        route: 'webinars',
        typeUser: 'courtier',
    }
]
